import Vue from "vue";
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from "vee-validate";
// import original rules
import * as originalRules from "vee-validate/dist/rules";
for (let rule in originalRules) {
  extend(rule, originalRules[rule]);
}
// import extended rules
// バリデーションルール取り込み
let hiragana = {
  validate(value) {
    let pattern = /^[\u3040-\u309f\u0020\u00a0\u3000\u30fb\u30fc]+$/;
    return pattern.test(value);
  }
};
let password = {
  validate(value) {
    let pattern = /^[a-z\d]{6,100}$/i;
    return pattern.test(value);
  }
};
let loginId = {
  validate(value) {
    let pattern = /^[a-z]{2}[0-9]{4}$/;
    return pattern.test(value);
  }
};
let rank = {
  validate(value) {
    if (value >= 0 && value <= 100) {
      return true;
    } else {
      return false;
    }
  }
};

extend("hiragana", hiragana);
extend("password", password);
extend("loginId", loginId);
extend("rank", rank);

// import original messages
import ja from "vee-validate/dist/locale/ja.json";
// setting validate dictionaries
localize({
  ja: { messages: { ...ja.messages } }
});
// initialize location
localize("ja");
// inject VeeValidate components
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
